import { UnitRounding } from '@shared/types';
import { getRoundingMethod } from 'shared/utils/numbers';
import { useOrgSettings } from 'src/modules/settings/orgSettings.store';

export default function useSystemUnitRounding() {
  const unitRounding = useOrgSettings((state) => state.orgSettings?.unitRounding);
  return getRoundingMethod(unitRounding as UnitRounding);
}
